import axios from 'axios';
import { getSubmissionBackendUrl } from '../constants/api-urls';
import { getAuth0AuthHeaders } from '../utils/auth0Session';

const submissionHeaders = () => getAuth0AuthHeaders();

export const fetchAccountCampaigns = async (accountUserId: string) => {
  const submissionBackendUrl = getSubmissionBackendUrl();
  const response = await axios.get(
    `${submissionBackendUrl}/curatorCampaign/campaigns/account/${encodeURIComponent(accountUserId)}`,
    { headers: submissionHeaders() }
  );

  return {
    campaigns: response?.data?.data || [],
    profiles: response?.data?.profiles || [],
  };
};

export const markAccountCampaignsSeen = async (accountUserId: string) => {
  const submissionBackendUrl = getSubmissionBackendUrl();
  await axios.patch(
    `${submissionBackendUrl}/curatorCampaign/mark_all_as_seen/account/${encodeURIComponent(accountUserId)}`,
    undefined,
    { headers: submissionHeaders() }
  );
};

export const fetchAccountUnseenCampaignCount = async (accountUserId: string): Promise<number> => {
  const submissionBackendUrl = getSubmissionBackendUrl();
  const response = await axios.get(
    `${submissionBackendUrl}/curatorCampaign/unseen_count/account/${encodeURIComponent(accountUserId)}`,
    { headers: submissionHeaders() }
  );
  return Number(response?.data?.data || 0);
};

export interface SyncEmailInvitesPayload {
  curatorProfileId: string;
  email: string;
  emailVerified: boolean;
  userId: string;
}

export const syncEmailInvitesForCurator = async (payload: SyncEmailInvitesPayload) => {
  const submissionBackendUrl = getSubmissionBackendUrl();
  await axios.post(`${submissionBackendUrl}/curatorCampaign/sync-email-invites`, payload, {
    headers: submissionHeaders(),
  });
};

export interface RejectCampaignPayload {
  userObjectId: string;
  campaignId: string;
}

export const rejectCampaign = async (payload: RejectCampaignPayload) => {
  const submissionBackendUrl = getSubmissionBackendUrl();
  const response = await axios.post(
    `${submissionBackendUrl}/artistCampaign/rejectCampaign`,
    payload,
    { headers: submissionHeaders() }
  );
  return response.data;
};

export interface RejectAllocationPayload {
  campaignId: string;
  curatorId: string;
  allocationId: string;
}

export const rejectAllocation = async (payload: RejectAllocationPayload) => {
  const submissionBackendUrl = getSubmissionBackendUrl();
  const response = await axios.post(
    `${submissionBackendUrl}/artistCampaign/rejectAllocation`,
    payload,
    { headers: submissionHeaders() }
  );
  return response.data;
};

export interface AcceptAllocationPayload {
  campaignId?: string;
  curatorId: string;
  allocationId?: string;
  playlistId: string;
  playlistName: string;
  playlistURL?: string;
  songPosition: number | string;
  songURI: string;
  songShareLink?: string;
  startTime?: string | null;
  endTime?: string | null;
  notes?: string;
  isScheduled?: boolean;
  scheduledStartTime?: string | null;
  playlistEntryId?: string;
  placements: Array<Record<string, unknown>>;
}

export const acceptAllocation = async (payload: AcceptAllocationPayload) => {
  const submissionBackendUrl = getSubmissionBackendUrl();
  await axios.post(`${submissionBackendUrl}/artistCampaign/acceptAllocation`, payload, {
    headers: submissionHeaders(),
  });
};

export interface UpdateCampaignWithSongInfoPayload {
  campaignId?: string;
  addedBy: string;
  playlistId: string;
  playlistName: string;
  playlistURL?: string;
  songPosition: number | string;
  songURI: string;
  songShareLink?: string;
  startTime?: string | null;
  endTime?: string | null;
  notes?: string;
  isScheduled?: boolean;
  scheduledStartTime?: string | null;
  playlistEntryId?: string;
  placements: Array<Record<string, unknown>>;
  [key: string]: unknown;
}

export const updateCampaignWithSongInfo = async (payload: UpdateCampaignWithSongInfoPayload) => {
  const submissionBackendUrl = getSubmissionBackendUrl();
  await axios.post(`${submissionBackendUrl}/artistCampaign/updateWithSongInfo`, payload, {
    headers: submissionHeaders(),
  });
};
